import { inject, Injectable } from '@angular/core';
import { type CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AuthSelectors } from '@ngrx-store';
import { map, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private store = inject(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(AuthSelectors.isLoggedIn),
      tap(async loggedIn => {
        if (loggedIn) {
          await this.router.navigateByUrl('dashboard');
        }
      }),
      map(loggedIn => !loggedIn),
    );
  }
}
